import { render, staticRenderFns } from "./TradingAccountTab.vue?vue&type=template&id=40fe2fa2"
import script from "./TradingAccountTab.vue?vue&type=script&lang=js"
export * from "./TradingAccountTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports